import { Box, Divider, Grid } from "@chakra-ui/react";
import { motion } from 'framer-motion';
import RankCard from "./RankCard";
import MarksAmountInfo from "./MarksAmountInfo";


const RankResults = ({ rankData, handleReset, csvData, twitterLink, isMobile, chartData, onMintModalOpen, isUserHasKey, isKeyMintAvailiable }) => {


	return (
		<Box>
			{rankData && (
				<motion.div
					initial={{ opacity: 0, y: 50 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.5 }}
				>
					{rankData.length > 1 ? (
						<Box w="100%" textAlign={"center"} px={4} overflowX="hidden" maxW={"1200px"}>
							<Grid
								templateColumns={{ base: '1fr', md: '1fr' }} // 1 column on small screens, 2 columns on medium and larger screens
								gap={4} // Adjust spacing between items
							>
								{rankData.map((data, index) => {
									return (
										<>
											<RankCard
												key={index} // Add a unique key for each item
												rankData={data}
												isKeyMintAvailiable={isKeyMintAvailiable}
												chartData={data.graphData}
												onMintModalOpen={onMintModalOpen}
												isUserHasKey={isUserHasKey}
												twitterLink={twitterLink}
											/>
											<MarksAmountInfo farming={data.farming} holding={data.holding} gasMarks={data.gasMarks} isMobile={isMobile} />
											{index < rankData.length - 1 && <Divider height={1} />}
										</>
									);
								})}

							</Grid>
						</Box>
					) : (
						<Box w="100%" textAlign={"center"} px={4} overflowX="hidden" maxW={"1200px"}>
							<Box>
							</Box>
							<RankCard
								rankData={rankData}
								isKeyMintAvailiable={isKeyMintAvailiable}
								chartData={chartData}
								onMintModalOpen={onMintModalOpen}
								isUserHasKey={isUserHasKey}
								twitterLink={twitterLink}
							/>
							<MarksAmountInfo farming={rankData.farming} holding={rankData.holding} gasMarks={rankData.gasMarks} />
						</Box>
					)}
				</motion.div>
			)}
		</Box>
	);
};

export default RankResults;
